// eslint-disable-next-line import/no-anonymous-default-export
export default {
  heading: 'Błąd 404',
  description: 'Nie możemy znaleźć strony, której szukasz.',
  descriptionBottom: 'Być może we wpisany przez Ciebie adres wkradła się literówka lub&nbsp;strona&nbsp;została&nbsp;przeniesiona.',
  button: {
    label: 'Powrót do strony głównej',
    href: '/pl'
  }
};
